export const languages = [
    {
        code: 'en',
        name: 'English'
    },
    {
        code: 'it',
        name: 'Italiano'
    },
    {
        code: 'es',
        name: 'Español'
    },
    {
        code: 'pt',
        name: 'Português'
    },
    {
        code: 'de',
        name: 'Deutsch'
    },
    {
        code: 'fr',
        name: 'Français'
    },
    {
        code: 'sl',
        name: 'Slovenščina'
    },
    {
        code: 'ru',
        name: 'Pусский'
    },
    {
        code: 'uk',
        name: 'Українська'
    },
    {
        code: 'pl',
        name: 'Polski'
    },
]